'use strict'
module.exports = require('./lib/api')(require('bindings')('keccak'))
